var App = App || {};

App.CmpMultiMedia = (function ($) {
    'use strict';

    function Click(button) {
        const play = $(button);
        const player = play.parents(".cmp--multiMedia__video");
        Play(player);
    }

    function Play(player) {
        // stop all other videos before starting a new one
        $(".cmp--multiMedia__video").each(function () { Stop($(this)); });

        // update the video from button to iframe
        const iframe = player.find(".cmp--multiMedia__iframe");
        const play = player.find(".cmp--multiMedia__play");
        const source = play.attr("data-src");
        const title = play.attr("data-title");

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                iframe.html(Youtube(source, title))
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                iframe.html(Vimeo(source, title));
                break;
            case source.toLowerCase().indexOf("intelligencebank") >= 0: //Custom
                iframe.html(IntelligenceBank(source, title));
                break;
            default:
                console.log("Could not locate video content");
        };

        play.hide();
        iframe.show();

        // if the video is in a modal add to the close event
        const modal = player.parents(".modal");
        if (modal.length > 0) {
            modal.on("hidden.bs.modal", function () {
                Stop(player);
            });
        }

    }

    function Stop(player) {
        const iframe = player.find(".cmp--multiMedia__iframe");
        const play = player.find(".cmp--multiMedia__play");

        iframe.hide().html("");
        play.show();
    }

    function Youtube(source, title) {
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    function Vimeo(source, title) {
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    function IntelligenceBank(source, title) { //Custom
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" class=\"intelligence-bank-iframe\" frameborder=\"0\" allowfullscreen></iframe>";
        return template;
    }

    function TranscriptAlignment(carousel) {
        var transcriptsHeight = 0;
        var transcripts = carousel.find(".cmp--multiMedia__transcript");
        transcripts.removeAttr("style").each(function () {
            transcriptsHeight = $(this).height() > transcriptsHeight ? $(this).height() : transcriptsHeight;
        });

        transcripts.height(transcriptsHeight);
    }

    return {
        Click: Click,
        Play: Play,
        Stop: Stop,
        TranscriptAlignment: TranscriptAlignment
    };

})(jQuery);
